import React, { useEffect, createElement } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { AgitationSection } from './components/AgitationSection';
import { ProductPresentation } from './components/ProductPresentation';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { UrgencySection } from './components/UrgencySection';
import { PricingSelector } from './components/PricingSelector';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      (window as any).fbq('init', '1349873706968654');
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-brand-cream text-brand-dark selection:bg-brand-gold/30 font-sans overflow-x-hidden" data-id="element-0">
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1349873706968654&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>

      <Header data-id="element-3" />
      <HeroSection data-id="element-4" />
      <PainSection data-id="element-5" />
      <AgitationSection data-id="element-6" />
      <ProductPresentation data-id="element-7" />
      <TomosSection data-id="element-8" />
      <BonusSection data-id="element-9" />
      <PricingSelector id="pricing" variant="primary" data-id="element-10" />
      <UrgencySection data-id="element-11" />
      <PricingSelector variant="final" data-id="element-12" />
      <Footer data-id="element-13" />
    </div>;
}